import { Tag } from 'antd';

import { CommunicationCampaignState } from '@seaters/constants';
import {
  alertColor,
  baseColor600,
  errorColor,
  successColor,
  tertiaryColor700,
} from '@seaters/ui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface MailcampaignStatusTagProps {
  status: CommunicationCampaignState;
  icon?: ReactNode;
}

const mailcampaignStatusToColor = {
  [CommunicationCampaignState.DRAFT]: baseColor600,
  [CommunicationCampaignState.FAILED]: errorColor,
  [CommunicationCampaignState.QUEUED]: alertColor,
  [CommunicationCampaignState.SCHEDULED]: tertiaryColor700,
  [CommunicationCampaignState.SENDING]: alertColor,
  [CommunicationCampaignState.SENT]: successColor,
};

const mailcampaignStatusTranslations: {
  [key in CommunicationCampaignState]: string;
} = {
  draft: 'mailcampaign_draft_label',
  failed: 'mailcampaign_failed_label',
  queued: 'mailcampaign_queued_label',
  scheduled: 'mailcampaign_scheduled_label',
  sending: 'mailcampaign_sending_label',
  sent: 'mailcampaign_sent_label',
};
export function MailcampaignStatusTag({
  status,
  icon,
}: MailcampaignStatusTagProps) {
  const { t } = useTranslation();
  return (
    <Tag icon={icon} color={mailcampaignStatusToColor[status]}>
      {t(mailcampaignStatusTranslations[status])}
    </Tag>
  );
}

export default MailcampaignStatusTag;
